import { format, startOfDay, subDays, subMonths } from "date-fns";
import * as React from "react";
import { ActiveDate } from "src/scenes/dashboard/date-provider";
import type { TemplateDashboard } from "src/components/template/types";

const printDateRange = (defaultDateRange?: TemplateDashboard["defaultDateRange"]) => {
    const { fromDate, toDate, handleChange } = React.useContext(ActiveDate);
    if (fromDate === null && toDate === null) {
        if (defaultDateRange === "month") {
            const to = subDays(startOfDay(new Date()), 1);
            return handleChange(subMonths(to, 1), to);
        }
        if (defaultDateRange === "6_months") {
            const to = subDays(startOfDay(new Date()), 1);
            return handleChange(subMonths(to, 6), to);
        }
        return "This week";
    }
    return `${format(fromDate ? new Date(fromDate) : new Date(), "d MMM yyyy")} - ${format(
        toDate ? new Date(toDate) : new Date(),
        "d MMM yyyy"
    )}`;
};

export default printDateRange;
